/* divos.lt — kategorijos / paieškos filtrai, rikiavimas, „Rodyti daugiau“, prekių ženklai */
(function () {
  const root = document.getElementById('CollectionSection') || document.getElementById('SearchSection');
  initBrands();
  if (!root) return;

  const sectionId = root.dataset.sectionId;
  const baseUrl = root.dataset.baseUrl || location.pathname;
  let controller = null;
  let timer = null;

  /* ---------- Pagalbinės ---------- */
  const getForm = () => document.getElementById('FacetForm') || document.getElementById('SortForm');

  function formQuery() {
    const form = getForm();
    if (!form) return '';
    const params = new URLSearchParams();
    new FormData(form).forEach((v, k) => { if (String(v).trim() !== '') params.append(k, v); });
    // Rikiavimas gali būti už formos ribų (atributas form="FacetForm") – FormData jį jau įtraukia.
    return params.toString();
  }

  function setLoading(on) {
    const res = document.getElementById('ProductResults');
    if (res) res.classList.toggle('is-loading', on);
    const f = document.getElementById('FacetForm');
    if (f) f.classList.toggle('is-loading', on);
  }

  function enhance() {
    const f = document.getElementById('FacetForm');
    if (f) f.classList.add('is-js');
    const pag = root.querySelector('[data-pagination]');
    if (pag && root.querySelector('[data-load-more]')) pag.hidden = true;
    root.querySelectorAll('[data-price-range]').forEach(initPrice);
  }

  /* ---------- Atnaujinimas per Section Rendering API ---------- */
  async function render(url, { push = true } = {}) {
    if (controller) controller.abort();
    controller = new AbortController();
    setLoading(true);
    const u = new URL(url, location.origin);
    u.searchParams.set('section_id', sectionId);
    try {
      const res = await fetch(u.toString(), { signal: controller.signal });
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');

      // Rezultatai
      const newRes = doc.getElementById('ProductResults');
      const curRes = document.getElementById('ProductResults');
      if (newRes && curRes) curRes.innerHTML = newRes.innerHTML;

      // Filtrai: išsaugome atidarytas skiltis ir slinkties vietą
      const curForm = document.getElementById('FacetForm');
      const newForm = doc.getElementById('FacetForm');
      if (curForm && newForm) {
        const inner = curForm.querySelector('[data-facet-inner]');
        const scroll = inner ? inner.scrollTop : 0;
        const openState = {};
        curForm.querySelectorAll('details[id]').forEach(d => { openState[d.id] = d.open; });
        const focusedName = document.activeElement && curForm.contains(document.activeElement) ? document.activeElement.name : null;
        curForm.querySelector('[data-facet-inner]').innerHTML = newForm.querySelector('[data-facet-inner]').innerHTML;
        const foot = curForm.querySelector('.f-foot'), newFoot = newForm.querySelector('.f-foot');
        if (foot && newFoot) foot.innerHTML = newFoot.innerHTML;
        curForm.querySelectorAll('details[id]').forEach(d => { if (d.id in openState) d.open = openState[d.id]; });
        const newInner = curForm.querySelector('[data-facet-inner]');
        if (newInner) newInner.scrollTop = scroll;
        if (focusedName) { const el = curForm.querySelector(`[name="${CSS.escape(focusedName)}"]`); if (el && el.type === 'number') el.focus(); }
      }

      if (push) {
        const clean = new URL(url, location.origin);
        clean.searchParams.delete('section_id');
        history.replaceState({}, '', clean.pathname + clean.search);
      }
      enhance();
    } catch (e) {
      if (e.name !== 'AbortError') location.href = url;
    } finally {
      setLoading(false);
    }
  }

  function submitForm(delay = 0) {
    clearTimeout(timer);
    timer = setTimeout(() => {
      const q = formQuery();
      const action = (getForm() && getForm().getAttribute('action')) || baseUrl;
      render(action + (q ? (action.includes('?') ? '&' : '?') + q : ''));
    }, delay);
  }

  /* ---------- Kainos slankiklis ---------- */
  function initPrice(box) {
    if (box.dataset.ready) return;
    box.dataset.ready = '1';
    const max = +box.dataset.max || 1;
    const rMin = box.querySelector('[data-range-min]'), rMax = box.querySelector('[data-range-max]');
    const nMin = box.querySelector('[data-price-min]'), nMax = box.querySelector('[data-price-max]');
    const fill = box.querySelector('[data-range-fill]');
    const paint = () => {
      const a = (+rMin.value / max) * 100, b = (+rMax.value / max) * 100;
      fill.style.left = a + '%'; fill.style.width = Math.max(0, b - a) + '%';
    };
    rMin.addEventListener('input', () => {
      if (+rMin.value > +rMax.value - 1) rMin.value = Math.max(0, +rMax.value - 1);
      nMin.value = +rMin.value > 0 ? rMin.value : '';
      paint();
    });
    rMax.addEventListener('input', () => {
      if (+rMax.value < +rMin.value + 1) rMax.value = Math.min(max, +rMin.value + 1);
      nMax.value = +rMax.value < max ? rMax.value : '';
      paint();
    });
    [rMin, rMax].forEach(r => r.addEventListener('change', () => submitForm(0)));
    nMin.addEventListener('input', () => { rMin.value = nMin.value || 0; paint(); });
    nMax.addEventListener('input', () => { rMax.value = nMax.value || max; paint(); });
    paint();
  }

  /* ---------- Įvykiai ---------- */
  document.addEventListener('change', e => {
    const t = e.target;
    if (!t.closest || !(t.closest('[data-facet-form]') || t.matches('[data-sort]'))) return;
    if (t.matches('[data-range-min],[data-range-max],[data-facet-search]')) return;
    if (t.matches('[data-price-min],[data-price-max]')) { submitForm(500); return; }
    submitForm(0);
  });

  document.addEventListener('submit', e => {
    const form = e.target.closest('[data-facet-form]');
    if (!form) return;
    e.preventDefault();
    submitForm(0);
  });

  // Paieška filtro reikšmių sąraše
  document.addEventListener('input', e => {
    const inp = e.target.closest('[data-facet-search]');
    if (!inp) return;
    const q = inp.value.trim().toLowerCase();
    const body = inp.closest('.f-body');
    let any = false;
    body.querySelectorAll('[data-facet-value]').forEach(l => {
      const hit = l.dataset.facetValue.toLowerCase().includes(q);
      l.hidden = !hit; if (hit) any = true;
    });
    const none = body.querySelector('[data-facet-none]');
    if (none) none.hidden = any;
  });

  document.addEventListener('click', e => {
    // Aktyvių filtrų pašalinimas, „Išvalyti“
    const link = e.target.closest('[data-facet-link]');
    if (link && root.contains(link)) {
      e.preventDefault();
      render(link.href);
      return;
    }
    // „Rodyti daugiau“
    const more = e.target.closest('[data-load-more]');
    if (more) {
      e.preventDefault();
      loadMore(more);
      return;
    }
    // Telefonas: filtrų langas
    if (e.target.closest('[data-ff-open]')) {
      document.body.classList.add('filters-open', 'lock');
    }
    const close = e.target.closest('[data-ff-close]');
    if (close) {
      if (close.matches('[data-ff-apply]')) e.preventDefault(); // rezultatai jau atnaujinti
      document.body.classList.remove('filters-open', 'lock');
    }
  });

  document.addEventListener('keydown', e => {
    if (e.key === 'Escape' && document.body.classList.contains('filters-open')) {
      document.body.classList.remove('filters-open', 'lock');
    }
  });

  async function loadMore(btn) {
    btn.classList.add('is-loading');
    btn.textContent = 'Kraunama…';
    const u = new URL(btn.href, location.origin);
    u.searchParams.set('section_id', sectionId);
    try {
      const html = await (await fetch(u.toString())).text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const grid = document.getElementById('ProductGrid');
      const newGrid = doc.getElementById('ProductGrid');
      if (grid && newGrid) grid.insertAdjacentHTML('beforeend', newGrid.innerHTML);
      const curMore = document.getElementById('LoadMore'), newMore = doc.getElementById('LoadMore');
      if (curMore && newMore) curMore.innerHTML = newMore.innerHTML;
      enhance();
    } catch (err) {
      location.href = btn.href;
    }
  }

  enhance();

  /* ---------- Prekių ženklų puslapis ---------- */
  function initBrands() {
    const page = document.getElementById('BrandsPage');
    if (!page) return;
    const ABC = ['A','Ą','B','C','Č','D','E','Ę','Ė','F','G','H','I','Į','Y','J','K','L','M','N','O','P','R','S','Š','T','U','Ų','Ū','V','Z','Ž'];
    const items = [...page.querySelectorAll('[data-brand]')].map(li => ({ name: li.dataset.brand, url: li.querySelector('a').href }));
    const letterOf = n => {
      const c = n.trim().charAt(0).toUpperCase();
      if (ABC.includes(c)) return c;
      const base = c.normalize('NFD').replace(/[̀-ͯ]/g, '');
      return ABC.includes(base) ? base : '#';
    };
    const esc = s => s.replace(/[&<>"]/g, m => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[m]));
    const groups = {};
    items.sort((a, b) => a.name.localeCompare(b.name, 'lt')).forEach(b => { (groups[letterOf(b.name)] ||= []).push(b); });
    const ORDER = ABC.concat(['#']);
    const lettersEl = page.querySelector('[data-letters]'), groupsEl = page.querySelector('[data-groups]');
    const empty = page.querySelector('[data-brands-empty]'), flat = page.querySelector('[data-brands-flat]');
    if (flat) flat.hidden = true;

    function draw(q) {
      const query = (q || '').trim().toLowerCase();
      const visible = {};
      let any = false;
      groupsEl.innerHTML = ORDER.filter(L => groups[L]).map(L => {
        const list = groups[L].filter(b => !query || b.name.toLowerCase().includes(query));
        if (!list.length) return '';
        visible[L] = any = true;
        return `<section class="br-group" id="br-${ORDER.indexOf(L)}"><h2>${L}</h2><ul>${list.map(b => {
          let label = esc(b.name);
          if (query) {
            const i = b.name.toLowerCase().indexOf(query);
            label = esc(b.name.slice(0, i)) + '<mark>' + esc(b.name.slice(i, i + query.length)) + '</mark>' + esc(b.name.slice(i + query.length));
          }
          return `<li><a href="${esc(b.url)}"><span class="nm">${label}</span></a></li>`;
        }).join('')}</ul></section>`;
      }).join('');
      lettersEl.innerHTML = ABC.map(L => visible[L]
        ? `<a href="#br-${ORDER.indexOf(L)}">${L}</a>`
        : `<a class="off" aria-disabled="true" tabindex="-1">${L}</a>`).join('');
      if (empty) empty.hidden = any;
    }
    draw('');
    const input = page.querySelector('[data-brand-search]');
    if (input) input.addEventListener('input', () => draw(input.value));
    lettersEl.addEventListener('click', e => {
      const a = e.target.closest('a[href]');
      if (!a) return;
      e.preventDefault();
      lettersEl.querySelectorAll('a').forEach(x => x.classList.toggle('on', x === a));
      const target = document.getElementById(a.getAttribute('href').slice(1));
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }
})();
